import { ProjectCreatedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import UserProjectsCountQuery from '../../queries/user/UserProjectsCountQuery';

export default ({ store }: ProjectCreatedDtoModelType) => async () => {
  const appStore = getAppRoot(store);

  await appStore.model.queryMe({}, UserProjectsCountQuery).currentPromise();
};
